<div class="manual-wrapper">

    <!-- ===== HEADER ===== -->
    <div class="manual-header">
        <div class="header-left">
            <div class="header-icon-wrap">
                <i class="pi pi-book"></i>
            </div>
            <div>
                <h1>Manual de Usuario</h1>
                <p>Sistema de Gestión ARCO — Guía interactiva por módulo</p>
            </div>
        </div>
        <div class="user-chip">
            <i class="pi pi-user-circle"></i>
            <span class="user-name">{{ user?.firstName }} {{ user?.lastName }}</span>
            @for (role of roles; track role) {
            <p-tag [value]="roleLabels[role]" [severity]="roleSeverity(role)" />
            }
        </div>
    </div>

    <!-- ===== BUSCADOR ===== -->
    <div class="search-bar">
        <p-iconfield>
            <p-inputicon styleClass="pi pi-search" />
            <input pInputText [(ngModel)]="searchQuery" placeholder="Buscar módulo..." class="search-input" />
        </p-iconfield>
        @if (searchQuery) {
        <span class="search-results">{{ searchedSections.length }} resultado(s)</span>
        }
    </div>

    <!-- ===== GRID DE MÓDULOS ===== -->
    <div class="modules-grid">
        @for (section of searchedSections; track section.key) {
        <div class="module-card" (click)="openSection(section)">
            <div class="card-accent" [style.background]="'var(' + section.colorVar + ')'"></div>
            <div class="card-body">
                <div class="card-top">
                    <div class="card-icon" [style.background]="'var(' + section.colorVar + ')'">
                        <i [class]="section.icon"></i>
                    </div>
                    <div class="card-text">
                        <h3>{{ section.title }}</h3>
                        <p>{{ section.subtitle }}</p>
                    </div>
                </div>
                <div class="card-bottom">
                    <div class="card-roles">
                        @if (section.requiredRoles.length === 0) {
                        <p-tag value="Todos los roles" severity="secondary" />
                        } @else {
                        @for (role of section.requiredRoles.slice(0, 3); track role) {
                        <p-tag [value]="roleLabels[role]" [severity]="roleSeverity(role)" />
                        }
                        @if (section.requiredRoles.length > 3) {
                        <p-tag [value]="'+' + (section.requiredRoles.length - 3)" severity="secondary" />
                        }
                        }
                    </div>
                    <span class="ver-btn">Ver manual <i class="pi pi-arrow-right"></i></span>
                </div>
            </div>
        </div>
        } @empty {
        <div class="empty-state">
            <i class="pi pi-search"></i>
            <p>
                No se encontraron módulos para "<strong>{{ searchQuery }}</strong>"
            </p>
        </div>
        }
    </div>
</div>

<!-- ===== DRAWER DE DETALLE ===== -->
<p-drawer [(visible)]="drawerVisible" position="right" styleClass="manual-detail-drawer" [modal]="true">

    @if (selectedSection) {

    <!-- Hero -->
    <div class="drawer-hero" [style.borderTopColor]="'var(' + selectedSection.colorVar + ')'">
        <div class="drawer-icon" [style.background]="'var(' + selectedSection.colorVar + ')'">
            <i [class]="selectedSection.icon"></i>
        </div>
        <div class="drawer-meta">
            <h2>{{ selectedSection.title }}</h2>
            <p>{{ selectedSection.subtitle }}</p>
            <div class="drawer-roles">
                @if (selectedSection.requiredRoles.length === 0) {
                <p-tag value="Disponible para todos los roles" severity="secondary" />
                } @else {
                @for (role of selectedSection.requiredRoles; track role) {
                <p-tag [value]="roleLabels[role]" [severity]="roleSeverity(role)" />
                }
                }
            </div>
        </div>
    </div>

    <!-- Tabs -->
    <p-tabs value="pantalla">
        <p-tablist>
            <p-tab value="pantalla"> <i class="pi pi-desktop tab-icon"></i> La Pantalla </p-tab>
            <p-tab value="procesos"> <i class="pi pi-list-check tab-icon"></i> Procesos </p-tab>
        </p-tablist>

        <p-tabpanels>
            <!-- ── TAB: La Pantalla ── -->
            <p-tabpanel value="pantalla">
                <div class="tab-scroll">
                    @for (element of currentElements; track element.title) {
                    <div class="screen-section">
                        <div class="screen-type-label">
                            <i [class]="elementTypeIcon(element.type)"></i>
                            {{ elementTypeLabel(element.type) }}
                        </div>
                        <h4 class="screen-section-title">{{ element.title }}</h4>
                        <div class="screen-items-list">
                            @for (item of element.items; track item.label) {
                            <div class="screen-item">
                                <div class="item-icon-wrap">
                                    @if (item.icon) {
                                    <i [class]="item.icon"></i>
                                    } @else {
                                    <i class="pi pi-minus"></i>
                                    }
                                </div>
                                <div class="item-content">
                                    <span class="item-label">{{ item.label }}</span>
                                    <span class="item-desc">{{ item.description }}</span>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    <p-divider />
                    } @empty {
                    <div class="empty-tab">
                        <i class="pi pi-lock"></i>
                        <p>No hay elementos de pantalla disponibles para tu rol.</p>
                    </div>
                    }
                </div>
            </p-tabpanel>

            <!-- ── TAB: Procesos ── -->
            <p-tabpanel value="procesos">
                <div class="tab-scroll">
                    @for (process of currentProcesses; track process.title) {
                    <div class="process-block">
                        <div class="process-header">
                            <div class="process-icon" [style.background]="'var(' + selectedSection.colorVar + ')'">
                                <i [class]="process.icon"></i>
                            </div>
                            <h4>{{ process.title }}</h4>
                        </div>
                        <ol class="process-steps">
                            @for (step of process.steps; track $index) {
                            <li>
                                <span class="step-num">{{ $index + 1 }}</span>
                                <span class="step-text">{{ step }}</span>
                            </li>
                            }
                        </ol>
                        @if (process.tip) {
                        <div class="tip-box">
                            <i class="pi pi-info-circle"></i>
                            <span>{{ process.tip }}</span>
                        </div>
                        }
                        @if (process.warn) {
                        <div class="warn-box">
                            <i class="pi pi-exclamation-triangle"></i>
                            <span>{{ process.warn }}</span>
                        </div>
                        }
                    </div>
                    <p-divider />
                    } @empty {
                    <div class="empty-tab">
                        <i class="pi pi-lock"></i>
                        <p>No hay procesos disponibles para tu rol en este módulo.</p>
                    </div>
                    }
                </div>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
    }
</p-drawer>